import { combineReducers } from '@reduxjs/toolkit';
import { overtimeCrudSlice } from './model/crudRequest';
import { overtimeSlice } from './model/Overtime';

const overtimeReducer = combineReducers({
  overtimeCrud: overtimeCrudSlice.reducer,
  overtime: overtimeSlice.reducer,
});

export default overtimeReducer;
